import React from 'react';
import { Link } from 'react-router-dom';
// import { Card } from 'react-bootstrap';
import CustomButton from '../customButton';
//import { Image } from 'react-bootstrap';
import productCard from './productCard.module.css';
// import CartImage from '../icons/cart';

// export function ProductCard({ product }) {

//     const {name, varenummer, image} = product.attributes;

//     const supplier = product.attributes.supplier.data.attributes.name;

//     return(
//         <div className="">
//             <Card className="mini-product-card">
//                 <div className="card-image-container">
//                     <Card.Img className="card-image-top" variant="top" src={image.data.attributes.url} alt={name}/>
//                 </div>
//                 <Card.Body className="d-flex flex-column">
//                     <Card.Title className="mini-product-card-title">
//                         {name}
//                     </Card.Title>
//                     <div className="mt-auto">
//                         <p>fra {supplier}</p>
//                     </div>
//                     <div className="mt-auto">
//                         {varenummer}
//                     </div>
//                     <div className="text-center mt-auto">
//                     <Link to={`product/${product.id}`}>
//                         <CustomButton 
//                             label="Trykk for mer info"
//                             className="mini-product-card-button text-white"
//                         />
//                     </Link>
//                     </div>
//                 </Card.Body>
//             </Card>
//         </div>
//     )
// }

// export default ProductCard;

export function ProductCard({ product }) {

    const {name, varenummer, image} = product.attributes;

    const supplier = product.attributes.supplier.data.attributes.name;

    return(
        <div className="">
            <div className={productCard.card}>
                <Link to={`/product/${product.id}`}>
                {/* <div className="col-12">
                    <Image className={productCard.cardImage} src={image.data.attributes.url} fluid alt={name}/>
                </div> */}
                <div className={productCard.imageContainer} 
                        style={{
                            backgroundImage: `url(${image.data.attributes.url})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain',
                            width: '10em',
                            height: '10em',
                        }}
                    />
                <div className="">
                    <div className={productCard.produktNavn}>
                        {name}
                    </div>
                    <div className="mt-auto">
                        <p>fra {supplier}</p>
                    </div>
                    <div className="mt-auto">
                        VN: {varenummer}
                    </div>
                    <div className="text-center mt-auto">
                    {/* <Link to={`/product/${product.id}`}> */}
                        <CustomButton 
                            label="Trykk for mer info"
                            className={productCard.cardButton}
                        />
                    {/* </Link> */}
                    </div>
                </ div>
                </Link>
            </ div>
        </div>
    )
}

export default ProductCard;